<template>
  <div class="container-fluid">
    <EmailSettings></EmailSettings>
    <hr>
    <EmailSettingsTest></EmailSettingsTest>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import EmailSettings from "./Settings.vue";
import EmailSettingsTest from "./Test.vue";

export default {
  components: {
    EmailSettings,
    EmailSettingsTest
  }
};
</script>

<style lang="scss">
</style>